import { useEffect } from 'react'
import * as store from '@store'
import { useWireState, useWireValue } from '@forminator/react-wire'
import { RT_EVENT_TYPE_UPDATE_DOC_STATUS } from '@/constants/realtime'
import deepmerge from 'deepmerge'

export const useRealtimeDocumentsStatus = context => {
    const notifications = useWireValue(store.notifications)
    const [documentsStore, setDocumentsStore] = useWireState(store.documents)
    const [runsheetStore, setRunsheetStore] = useWireState(store.currentRunsheet)
    const remoteConfig = useWireValue(store.remoteConfig)
    
    const handleWithRunsheetDocuments = docs => {
        const updatedRunsheet = { ...runsheetStore }
        
        if (!updatedRunsheet?.rdj?.length) return
        
        updatedRunsheet?.rdj?.forEach((rdjItem, i) => {
            const updatedDoc = docs.find(d => d.id === rdjItem.document.id)
            
            if (updatedDoc) {
                updatedRunsheet.rdj[i] = {
                    ...rdjItem,
                    document: {
                        ...rdjItem.document,
                        reviewStatus: updatedDoc.reviewStatus ?? rdjItem.document.reviewStatus,
                        orgStatus: updatedDoc.orgStatus ?? rdjItem.document.orgStatus,
                    },
                }
            }
        })
        
        setRunsheetStore({ ...updatedRunsheet, rdj: [...updatedRunsheet.rdj] })
    }
    
    const handleWithCollectionDocuments = docs => {
        const updatedDocuments = documentsStore.rows?.map(doc => {
            const updatedDoc = docs.find(d => d.id === doc.id)
            
            if (updatedDoc) {
                return deepmerge(doc, {
                    reviewStatus: updatedDoc.reviewStatus ?? doc.reviewStatus,
                    orgStatus: updatedDoc.orgStatus ?? doc.orgStatus,
                })
            }
            
            return doc
        })
        
        setDocumentsStore({
            ...documentsStore,
            rows: updatedDocuments,
        })
    }
    
    useEffect(() => {
        
        if (!remoteConfig?.realtimeEnabled) return
        
        const latestNotifications = notifications
            .filter(notification => notification.message.data.type === RT_EVENT_TYPE_UPDATE_DOC_STATUS)
            .reduce((acc, notification) => {
                const {
                    data: { documentId, createdAt },
                } = notification.message.data
                
                if (!acc[documentId] || new Date(createdAt) > new Date(acc[documentId].data.createdAt)) {
                    acc[documentId] = notification.message.data
                }
                
                return acc
            }, {})
        
        const updatedDocs = Object.keys(latestNotifications).map(docId => {
            const notification = latestNotifications[docId]
            
            const { data: { reviewStatus, orgStatus } } = notification
            
            return {
                id: docId,
                reviewStatus: reviewStatus !== undefined ? reviewStatus : null,
                orgStatus: orgStatus !== undefined ? orgStatus : null,
            }
        })
        
        if (context === 'runsheet')
            handleWithRunsheetDocuments(updatedDocs)
        else if (context === 'collection')
            handleWithCollectionDocuments(updatedDocs)
        
    }, [notifications])
    
}
